import { useEffect, useState } from "react";
import { Note } from "../components/Note";
import { API } from "../core/api";
import {
  convertParamsIdToNumber,
  formatAntdJalaliDate,
  toEnglishNumber,
} from "../core/utils";
import { useHistory, useLocation } from "react-router-dom";
import { parse, stringify } from "query-string";
import { onChangeProvince } from "../core/utils";
import FileSaver from "file-saver";

const useDrivers = ({ isInDriversPage }) => {
  const [isAddDriverModalOpen, setIsAddDriverModalOpen] = useState(false);
  const [isRemovePlateNumberModalOpen, setIsRemovePlateNumberModalOpen] =
    useState(false);
  const [cities, setCities] = useState([]);

  const [loadDrivers, setLoadDrivers] = useState(false);
  const [drivers, setDrivers] = useState([
    {
      pk: 5001123,
      is_active: true,

      user: {
        id: 5001123,
        fullname: "Mohammed Al-Saud",
        first_name: "Mohammed",
        last_name: "Al-Saud",
        phone_number: "0501234567",
        national_id: "1234567890",
      },
      created_at: "2023/05/21",
      plate_number: "ه ع ب ٤٥٦٧ / H A B 4567",
      province: "Riyadh",
      city: "Riyadh",
    },
    {
      pk: 5004567,
      is_active: true,
      user: {
        id: 5004567,
        fullname: "Fatima Al-Ghamdi",
        first_name: "Fatima",
        last_name: "Al-Ghamdi",
        phone_number: "0559876543",
        national_id: "9876543210",
      },
      created_at: "2024/11/01",
      plate_number: "ب د س ٢٣٤٥ / B D S 2345",
      province: "Madinah",
      city: "Madinah",
    },
    {
      pk: 5007890,
      is_active: false,
      user: {
        id: 5007890,
        fullname: "Ahmad Al-Zahrani",
        first_name: "Ahmad",
        last_name: "Al-Zahrani",
        phone_number: "0531122334",
        national_id: "1122334455",
      },
      created_at: "2022/03/15",
      plate_number: "س ك ل ٠٠١٢ / S K L 0012",
      province: "Jeddah",
      city: "Jeddah",
    },
    {
      pk: 5002233,
      is_active: true,

      user: {
        id: 5002233,
        fullname: "Khalid Al-Otaibi",
        first_name: "Khalid",
        last_name: "Al-Otaibi",
        phone_number: "0594455667",
        national_id: "4455667788",
      },
      created_at: "2025/01/10",
      plate_number: "ج ر د ٧٨٩٠ / J R D 7890",
      province: "Dammam",
      city: "Dammam",
    },
    {
      pk: 5009900,
      is_active: true,
      province: "Hail",
      city: "Hail",
      user: {
        id: 5009900,
        fullname: "Nora Al-Harbi",
        first_name: "Nora",
        last_name: "Al-Harbi",
        phone_number: "0547788990",
        national_id: "7788990011",
      },
      created_at: "2024/09/30",
      plate_number: "ق ه ل ١١١١ / Q H L 1111",
    },
  ]);

  const [pagination, setPagination] = useState({});

  const history = useHistory();
  const location = useLocation();
  const params = parse(location.search);

  const [filters, setFilters] = useState({
    province_id: convertParamsIdToNumber(params.province_id),
    city_id: convertParamsIdToNumber(params.city_id),
    created_date: [
      params.created_start_date || null,
      params.created_end_date || null,
    ].filter((date) => date),
    first_name: params.first_name || null,
    last_name: params.last_name || null,
    username: params.username || null,
    search: params.search || null,
    national_id: params.national_id || null,
  });
  const [driverState, setDriverState] = useState({
    province_id: null,
    city_id: null,
    first_name: "",
    last_name: "",
    national_id: "",
    phone_number: "",
  });

  const onAddDriver = () => {
    const newDriverState = {
      ...driverState,
      national_id: toEnglishNumber(driverState.national_id),
      phone_number: toEnglishNumber(driverState.phone_number),
    };
    if (!newDriverState.city_id) {
      return Note.error("شهر الزامی است");
    }
    if (!newDriverState.first_name) {
      return Note.error("نام الزامی است");
    }
    if (!newDriverState.last_name) {
      return Note.error("نام خانوادگی الزامی است");
    }
    if (!newDriverState.national_id) {
      return Note.error("کد ملی الزامی است");
    }
    if (!newDriverState.phone_number) {
      return Note.error("شماره موبایل الزامی است");
    }
    delete newDriverState.province_id;
    // API.post.post_driver(newDriverState).then((response) => {
    //   if (response.success) {
    //     onFilterDrivers();
    //     setDriverState({
    //       province_id: null,
    //       city_id: null,
    //       first_name: "",
    //       last_name: "",
    //       national_id: "",
    //       phone_number: "",
    //     });
    //     Note.success(response.message);
    //     setIsAddDriverModalOpen(false);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const handleAddDriverStateChange = (data) => {
    setDriverState({
      ...driverState,
      ...data,
    });
  };

  const onFilterDrivers = (page, disableFilters = false) => {
    // setLoadDrivers(true);
    const form_created_start_date =
      filters.created_date.length &&
      filters.created_date[0] &&
      typeof filters.created_date[0] === "object"
        ? formatAntdJalaliDate(filters.created_date[0])
        : filters.created_date
        ? filters.created_date[0]
        : null;

    const form_created_end_date =
      filters.created_date.length &&
      filters.created_date[1] &&
      typeof filters.created_date[1] === "object"
        ? formatAntdJalaliDate(filters.created_date[1])
        : filters.created_date
        ? filters.created_date[1]
        : null;

    const newFilters = {
      ...filters,
      ...((page || pagination) && { page: page || pagination?.page }),
      username: toEnglishNumber(filters.username || ""),
      created_start_date: filters.created_date ? form_created_start_date : null,
      created_end_date: filters.created_date ? form_created_end_date : null,
      search:
        filters.search && !isNaN(filters.search)
          ? toEnglishNumber(filters.search)
          : filters.search,
    };

    delete newFilters.created_date;
    if (isInDriversPage && !disableFilters)
      history.push({ pathname: "/drivers/", search: stringify(newFilters) });
    // API.get.drivers(disableFilters ? {} : newFilters).then((response) => {
    //   if (response.success) {
    //     setLoadDrivers(false);
    //     setDrivers(response.data);
    //     setPagination(response.pagination);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const getDriversReport = () => {
    const form_created_start_date =
      filters.created_date.length &&
      filters.created_date[0] &&
      typeof filters.created_date[0] === "object"
        ? formatAntdJalaliDate(filters.created_date[0])
        : filters.created_date
        ? filters.created_date[0]
        : null;

    const form_created_end_date =
      filters.created_date.length &&
      filters.created_date[1] &&
      typeof filters.created_date[1] === "object"
        ? formatAntdJalaliDate(filters.created_date[1])
        : filters.created_date
        ? filters.created_date[1]
        : null;

    const newFilters = {
      ...filters,
      ...(pagination && { page: pagination?.page }),
      username: toEnglishNumber(filters.username || ""),
      created_start_date: form_created_start_date,
      created_end_date: form_created_end_date,
      search:
        filters.search && !isNaN(filters.search)
          ? toEnglishNumber(filters.search)
          : filters.search,
      get_report: true,
    };

    // API.get
    //   .drivers_report(newFilters)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       return response.blob();
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .then((blob) => {
    //     FileSaver.saveAs(blob, `drivers-report.xlsx`);
    //   });
  };

  const changePage = (page) => {
    console.log(page);
    setPagination({
      ...pagination,
      page,
    });
    onFilterDrivers(page);
  };

  useEffect(() => {
    onFilterDrivers();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (params.province_id && !cities.length) {
      onChangeProvince(params.province_id, null, setCities);
    }
    // eslint-disable-next-line
  }, [history]);

  const onChangeFilters = (data) => {
    setFilters({ ...filters, ...data });
  };

  const onRemovePlate = (data, remove_plate, remove_driver) => {
    const newData = {
      company_driver_id: data.pk,
      city_id: cities.find((city) => city.name === data.city)?.id,
      first_name: data.user.first_name,
      last_name: data.user.last_name,
      national_id: data.user.national_id,
      ...(remove_plate && { remove_plate }),
      ...(remove_driver && { remove_driver }),
    };
    // API.put.put_driver(newData).then((response) => {
    //   if (response.success) {
    //     Note.success(response.message);
    //     setIsRemovePlateNumberModalOpen(false);
    //     onFilterDrivers();
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  return {
    loadDrivers,
    drivers,
    pagination,
    isAddDriverModalOpen,
    setIsAddDriverModalOpen,
    filters,
    driverState,
    cities,
    setCities,
    onChangeFilters,
    handleAddDriverStateChange,
    onFilterDrivers,
    onAddDriver,
    onRemovePlate,
    isRemovePlateNumberModalOpen,
    setIsRemovePlateNumberModalOpen,
    changePage,
    getDriversReport,
  };
};

export default useDrivers;
